import React, { useState, useEffect, useRef } from "react";
import { db } from "./firebase";
import {
  doc,
  setDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Card,
  Link,
  CardContent,
  TextField,
  Alert,
  LinearProgress,
  Fade,
  Drawer,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import TestResultComponent from "./TestResultComponent";

import { useTheme } from "@mui/material/styles";
import { getStyles } from "../index";
import Logger from "./Logger";
import TestInProgressComponent from "./TestInProgressComponent";
import GenerateHP from "./GenerateHP";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import AddIcon from "@mui/icons-material/Add";

import ExploreIcon from "@mui/icons-material/Explore";
import HPDrawerComponent from "./hp/HPDrawerComponent";
import { Helmet } from "react-helmet-async";

import { Compare, PieChart } from "@mui/icons-material";
import {
  AutoStories,
  Spellcheck,
  TextFields,
  Calculate,
  Extension,
  Language,
} from "@mui/icons-material";

import { v4 as uuidv4 } from "uuid";
import LoadingSpinner from "./LoadingSpinner";

import { Grid, Tooltip } from "@mui/material";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import { Howl } from "howler";
import selectSoundFile from "./sounds/select.mp3";
import select2 from "./sounds/select2.mp3";
import SegmentIcon from "@mui/icons-material/Segment";
import done from "./sounds/done.mp3";

import { useSnackbar } from "./SnackbarHandler";

import InfoIcon from "@mui/icons-material/Info";

import { keyframes } from "@mui/system";

///// TILL HIT //////
import { TestSelector, IncompleteTestDialog } from "./TestComponents2";
import { getHpDataById, availableTests } from "./hpData";

import AIDialog from "./AIDialog";
import { useParams, useNavigate } from "react-router-dom";

import DynamicMathChart from "./DynamicMathChart";

const HP = ({ user }) => {
  const [hpTest, setHpTest] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoadingTests, setIsLoadingTests] = useState(true);
  const [results, setResults] = useState([]);
  const [showSummary, setShowSummary] = useState(false);

  const [isTestLoading, setIsTestLoading] = useState(false);
  const [openAIDialogs, setOpenAIDialogs] = useState({});

  const [testInProgress, setTestInProgress] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [answeredQuestions, setAnsweredQuestions] = useState({});
  const [savedQuestions, setSavedQuestions] = useState({});

  const theme = useTheme();
  const styles = getStyles(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const selectSound = new Howl({ src: [selectSoundFile], volume: 0.1 });
  const nextSound = new Howl({ src: [select2], volume: 0.6 });
  const doneSound = new Howl({ src: [done], volume: 0.2 });

  const [showTestSelector, setShowTestSelector] = useState(true);
  const [selectedTestId, setSelectedTestId] = useState(
    availableTests[0]?.id || null,
  );
  const [isOverviewOpen, setIsOverviewOpen] = useState(false);
  const [userProgress, setUserProgress] = useState([]);

  const [incompleteDialogOpen, setIncompleteDialogOpen] = useState(false);
  const [focusModeActive, setFocusModeActive] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);

  const [aiDialogOpen, setAiDialogOpen] = useState(false);
  const [aiResponse, setaiResponse] = useState("");

  const [currentHpName, setCurrentHpName] = useState("");

  const messagesEndRef = React.useRef(null);

  const [isSaved, setIsSaved] = useState(false);

  const { showSnackbar } = useSnackbar();

  const [allTests, setAllTests] = useState([]);

  const [timeLeft, setTimeLeft] = useState(55 * 60);
  const timeLeftRef = useRef(55 * 60);
  const timerRef = useRef(null);
  const timerDisplayRef = useRef(null);

  const [progress, setProgress] = useState(0);

  const [showOverlay, setShowOverlay] = useState(false);
  const [overviewLoading, setOverviewLoading] = useState(false);

  const [showManualTest, setShowManualTest] = useState(false);

  const [manualTestName, setManualTestName] = useState("");
  const [manualTestJson, setManualTestJson] = useState("");
  const initialHpTestIds = [
    "LExXv2PZoCz2xbfBZ8xk",
    "f1BIyylYSivZM7vFzlQA",
    "iQzSOWvLHifNoqzcBJ1i",
    "sf09lktI5St09Z7nzkpr",
  ];

  const [dynamicTitle, setDynamicTitle] = useState(
    "Alla högskoleprov — Gamla högskoleprov & AI-genererade | Studera.AI",
  );
  const [dynamicDescription, setDynamicDescription] = useState(
    "Öva på gamla och AI-genererade högskoleprov. Förbered dig effektivt med vår omfattande provbank.",
  );

  const handleOpenAIDialog = (index) => {
    setOpenAIDialogs((prev) => ({ ...prev, [index]: true }));
  };

  const handleCloseAIDialog = (index) => {
    setOpenAIDialogs((prev) => ({ ...prev, [index]: false }));
  };

  useEffect(() => {
    addSpecializedHPTests();
  }, []);

  async function addSpecializedHPTests() {
    try {
      const hpTestsSnapshot = await getDocs(collection(db, "hpPublic"));
      const allTests = hpTestsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Filter for official tests only
      const officialTests = allTests.filter((test) => test.official === true);

      // Extract ORD questions from official tests
      const ordQuestions = officialTests.flatMap((test) =>
        test.data.questions
          .filter((q) => q.questionType === "MEK")
          .flatMap((q) => q.questions),
      );

      // Extract LÄS questions from official tests
      const lasQuestions = officialTests.flatMap((test) =>
        test.data.questions.filter((q) => q.questionType === "ELF"),
      );

      // Create new ORD test
      const ordTest = {
        name: "MEK-delen",
        official: false,
        questionTypeTest: "MEK",
        specificPart: true,
        data: {
          questions: [
            {
              questionType: "MEK",
              questions: ordQuestions,
            },
          ],
        },
        upvotes: 420,
        downvotes: 0,
        userVotes: {},
      };

      // Create new LÄS test
      const lasTest = {
        name: "ELF-delen",
        official: false,
        specificPart: true,
        questionTypeTest: "ELF",
        data: {
          questions: lasQuestions,
        },
        upvotes: 134,
        downvotes: 0,
        userVotes: {},
      };

      // const ordDocRef = await addDoc(collection(db, 'hpPublic'), ordTest);
      // Logger.log('ORD test added with ID: ', ordDocRef.id);

      // const lasDocRef = await addDoc(collection(db, 'hpPublic'), lasTest);
      // Logger.log('LÄS test added with ID: ', lasDocRef.id);

      Logger.log("Specialized HP tests added successfully!");
    } catch (error) {
      Logger.error("Error adding specialized HP tests: ", error);
    }
  }

  const copyInitialHpTestsForNewUser = async (userId, hpTestIds) => {
    try {
      for (const hpTestId of hpTestIds) {
        const publicHpTestRef = doc(db, "hpPublic", hpTestId);
        const publicHpTestSnap = await getDoc(publicHpTestRef);

        if (publicHpTestSnap.exists()) {
          const hpTestData = publicHpTestSnap.data();

          const hpTestCopy = {
            ...hpTestData,
            uid: userId,
            createdAt: new Date(),
            official: true,
            isPublicCopy: true,
            isGenerated: true,
          };
          await setDoc(doc(db, "hpTestData", hpTestId), hpTestCopy);
          Logger.log(`HP Test ${hpTestId} copied for new user ${userId}`);
        } else {
          console.error(`Public HP Test with ID ${hpTestId} not found`);
        }
      }
      Logger.log(`Initial HP Tests copied successfully for user ${userId}`);
    } catch (error) {
      console.error("Error copying initial HP Tests: ", error);
    }
  };

  const copyTest = async (event) => {
    await copyInitialHpTestsForNewUser(user.uid, initialHpTestIds);
  };

  const handleManualTestSubmit = async (event) => {
    event.preventDefault();
    try {
      const parsedJson = JSON.parse(manualTestJson);
      const hpPublicData = {
        name: manualTestName,
        official: true,
        data: parsedJson,
        upvotes: 0,
        downvotes: 0,
        userVotes: {},
      };
      const hpPublicDocRef = await addDoc(
        collection(db, "hpPublic"),
        hpPublicData,
      );
      Logger.log("Manual test added with ID: ", hpPublicDocRef.id);
      showSnackbar("Test added successfully!", "success");
      setManualTestName("");
      setManualTestJson("");
    } catch (error) {
      console.error("Error adding manual test: ", error);
      showSnackbar("Error adding test. Please check your JSON.", "error");
    }
  };

  const toggleFocusMode = () => {
    setFocusModeActive(!focusModeActive);
  };

  const { testId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (testId) {
      handleSelectTest(testId);
    }
  }, [testId]);

  const handleDeleteGeneratedTest = async (testId) => {
    if (!user) return;

    try {
      // Delete the test from Firestore
      await deleteDoc(doc(db, "hpTestData", testId));

      // Remove the test from allTests state
      setAllTests((prevTests) =>
        prevTests.filter((test) => test.id !== testId),
      );

      // Remove any associated progress
      await deleteDoc(doc(db, "hpTestProgress", `${user.uid}_${testId}`));

      // Remove from userProgress state
      setUserProgress((prevProgress) =>
        prevProgress.filter((p) => p.testId !== testId),
      );

      Logger.log(`Generated test ${testId} has been deleted`);
    } catch (error) {
      console.error("Error deleting generated test:", error);
    }
  };

  const fetchAllTests = async (uid) => {
    // Fetch user's tests from Firestore
    // const userTestsQuery = query(
    //   collection(db, "hpTestData"),
    //   where("uid", "==", uid),
    // );
    // const querySnapshot = await getDocs(userTestsQuery);
    // const userTests = querySnapshot.docs.map((doc) => ({
    //   id: doc.id,
    //   ...doc.data(),
    // }));
    // const updatedTests = await Promise.all([
    //   // Moonshine: tror jag använde detta för testsyfte eller? vetefan. jo, det är för gamla hp du lagt in i ny json redo att laddas upp, att testa innan uppladdning
    //   // ...availableTests.map(async (test) => {
    //   //   const testData = await getHpDataById(test.id);
    //   //   const questionTypes = [...new Set(testData.questions.map(q => q.questionType))];
    //   //   return { ...test, questionTypes, isGenerated: false, isFromHpData: true };
    //   // }),
    //   ...userTests.map(async (test) => {
    //     const questionTypes = [
    //       ...new Set(test.data.questions.map((q) => q.questionType)),
    //     ];
    //     return { ...test, questionTypes, isGenerated: true };
    //   }),
    // ]);
    // setAllTests(updatedTests);
  };

  useEffect(() => {
    if (showTestSelector) {
      setDynamicTitle("Skapa prov med AI | Studera.AI");
      setDynamicDescription(
        "Generera högskoleprov med AI för olika frågetyper som ORD, LÄS, MEK, XYZ, ELF, DTK m.fl. Perfekt alternativ till att träna på gamla högskoleprov.",
      );

      setIsLoadingTests(true);
      const timer = setTimeout(() => {
        fetchAllTests(user.uid).then(() => {
          setIsLoadingTests(false);
        });
      }, 2000); // Delay for 2 seconds

      return () => clearTimeout(timer);
    }
  }, [showTestSelector, user]);

  const progressRef = useRef(null);
  const progressPercentRef = useRef(null);
  const updateProgress = (value) => {
    if (progressRef.current) {
      progressRef.current.style.width = `${value}%`;
    }
    if (progressPercentRef.current) {
      progressPercentRef.current.textContent = `${Math.round(value)}%`;
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [aiResponse]);

  // Ändra availableTests till allTests?
  useEffect(() => {
    if (availableTests.length > 0 && !selectedTestId) {
      setSelectedTestId(availableTests[0].id);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchUserProgress().then(setUserProgress);
    }
  }, [user]);

  useEffect(() => {
    if (drawerOpen) {
      fetchUserProgress().then(setUserProgress);
    }
  }, [drawerOpen]);

  function getFirst6Digits(timestamp) {
    // Convert the timestamp to a string and take the first 6 characters
    return timestamp.toString().slice(0, 6);
  }

  const fetchUserProgress = async () => {
    if (!user) return [];
    try {
      const q = query(
        collection(db, "hpTestProgress"),
        where("userId", "==", user.uid),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => {
        const data = doc.data();
        const test = allTests.find((t) => t.id === data.testId);
        const answeredQuestionsCount = data.results ? data.results.length : 0;
        Logger.log(`Test ${data.testId}:`, {
          results: data.results,
          answeredQuestionsCount,
          totalQuestions:
            data.totalQuestions || test?.questions?.length || "unknown",
        });
        return {
          ...data,
          testName: test ? test.name : "Okänt test",
          testId: data.testId,
          answeredQuestionsCount,
          totalQuestions: data.totalQuestions || test?.questions?.length || 0,
        };
      });
    } catch (error) {
      console.error("Error fetching user progress:", error);
      return [];
    }
  };

  useEffect(() => {
    Logger.log("selectedTestId changed to:", selectedTestId);
  }, [selectedTestId]);

  useEffect(() => {
    const fetchTestData = async () => {
      if (selectedTestId) {
        try {
          const testDoc = await getDoc(doc(db, "hpTestData", selectedTestId));
          if (testDoc.exists()) {
            //saveProgress();
            const testData = testDoc.data();
            setCurrentHpName(testData.name);
            Logger.log("currentHpName: ", currentHpName);
            setHpTest(testData.data.questions);
            Logger.log("Set hpTest to:", testData);

            const titlePrefix = testData.official
              ? "Gammalt högskoleprov"
              : "AI-genererat högskoleprov";
            const descriptionPrefix = testData.official
              ? "Öva på gammalt"
              : "Öva på AI-genererat";

            setDynamicTitle(`${testData.name} — ${titlePrefix} — Studera.AI`);
            setDynamicDescription(
              `${descriptionPrefix} högskoleprov: ${testData.name}`,
            );
          } else {
            Logger.log(
              "No test found in database with the ID:",
              selectedTestId,
            );

            //saveProgress();
            const fallbackData = getHpDataById(selectedTestId);

            setHpTest(fallbackData.questions);
            //Logger.log("Set hpTest to:", fallbackData.questions);
          }
        } catch (error) {
          console.error("Error loading HP test data:", error);
        }
      } else {
        Logger.log("No test selected yet or test not in progress");
      }
    };

    fetchTestData();
  }, [selectedTestId, testInProgress]);

  const calculateTotalQuestions = (testData) => {
    Logger.log("Calculating total questions for:", testData);
    const total = testData.reduce((total, section) => {
      //Logger.log("Section:", section);
      return total + (section.questions ? section.questions.length : 0);
    }, 0);
    Logger.log("Calculated total questions:", total);
    return total;
  };

  const handleSaveQuestion = () => {
    setResults((prevResults) => {
      const existingIndex = prevResults.findIndex(
        (r) =>
          r.sectionIndex === currentSectionIndex &&
          r.questionIndex === currentQuestionIndex,
      );

      let updatedResults;
      if (existingIndex !== -1) {
        // If the question is already in results, update its 'saved' status
        updatedResults = [...prevResults];
        updatedResults[existingIndex] = {
          ...updatedResults[existingIndex],
          saved: true,
        };
      } else {
        // If the question is not in results, add it with 'saved' status
        const newResult = {
          sectionIndex: currentSectionIndex,
          questionIndex: currentQuestionIndex,
          questionType: hpTest[currentSectionIndex].questionType,
          question:
            hpTest[currentSectionIndex].questions[currentQuestionIndex]
              .question,
          saved: true,
        };
        updatedResults = [...prevResults, newResult];
      }

      // Call saveProgress with the updated results
      saveProgress({ results: updatedResults });
      showSnackbar("Fråga sparad!", "success");
      return updatedResults;
    });

    // Set isSaved to true and schedule it to be set back to false after 3 seconds
    setIsSaved(true);
    setTimeout(() => setIsSaved(false), 3000);
  };

  const saveProgress = async (updatedState = {}) => {
    if (!user || !selectedTestId || !hpTest) {
      console.error("Missing required data for saving progress:", {
        user,
        selectedTestId,
        hpTest,
      });
      return;
    }

    const totalQuestions = calculateTotalQuestions(hpTest);
    const answeredQuestionsCount = results.length;

    const progressData = {
      userId: user.uid,
      testId: selectedTestId,
      testName: currentHpName,
      currentSectionIndex,
      currentQuestionIndex,
      results,
      timeLeft: timeLeftRef.current,
      testInProgress: answeredQuestionsCount < totalQuestions,
      totalQuestions,
      lastUpdated: new Date(),
      ...updatedState,
    };

    try {
      Logger.log("Saving progress with data:", progressData);
      await setDoc(
        doc(db, "hpTestProgress", `${user.uid}_${selectedTestId}`),
        progressData,
      );
    } catch (error) {
      console.error("Error saving progress:", error);
    }
  };

  const loadProgress = async (testId) => {
    Logger.log("Loading progress for testId:", testId);
    if (!user) return;

    try {
      const docRef = doc(db, "hpTestProgress", `${user.uid}_${testId}`);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        Logger.log("Loaded progress data:", data);

        // Fetch test data
        let testData = await getTestData(testId);

        const maxSectionIndex = testData.questions.length - 1;

        setCurrentSectionIndex(
          Math.min(data.currentSectionIndex, maxSectionIndex),
        );
        setCurrentQuestionIndex(data.currentQuestionIndex);
        setResults(data.results);
        setTimeLeft(data.timeLeft);
        setTestInProgress(data.testInProgress);

        setHpTest(testData.questions);

        const titlePrefix = testData.official
          ? "Gammalt högskoleprov"
          : "AI-genererat högskoleprov";
        const descriptionPrefix = testData.official
          ? "Öva på gammalt"
          : "Öva på AI-genererat";

        setDynamicTitle(`${data.testName} — ${titlePrefix} — Studera.AI`);
        setDynamicDescription(
          `${descriptionPrefix} högskoleprov: ${data.testName}`,
        );
      } else {
        Logger.log("No existing progress found for this test");
        // Set initial state
        setCurrentSectionIndex(0);
        setCurrentQuestionIndex(0);
        setResults([]);
        setTimeLeft(55 * 60);
        setTestInProgress(true);
      }
    } catch (error) {
      console.error("Error loading progress:", error);
    }
  };

  const getTestData = async (testId) => {
    const testDocRef = doc(db, "hpTestData", testId);
    const testDocSnap = await getDoc(testDocRef);

    if (testDocSnap.exists()) {
      return testDocSnap.data().data;
    } else {
      return getHpDataById(testId);
    }
  };

  const handleSelectTest = async (selectedTestId) => {
    setIsTestLoading(true);
    Logger.log("Selected test:", selectedTestId);
    if (!selectedTestId) {
      console.error("No testId provided to handleSelectTest");
      return;
    }

    setSelectedTestId(selectedTestId);
    Logger.log("Set selectedTestId to:", selectedTestId);

    setShowTestSelector(false);
    setCurrentSectionIndex(0);
    setCurrentQuestionIndex(0);

    await loadProgress(selectedTestId);

    const docRef = doc(db, "hpTestProgress", `${user.uid}_${selectedTestId}`);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      Logger.log("No existing progress found, starting new test");
      startTest(selectedTestId);
    } else {
      Logger.log("Existing progress found, loaded");
      setTestInProgress(true);
    }

    setIsTestLoading(false);
    //navigate(`/app/hp/${selectedTestId}`);
  };

  const handleBackToSelector = async () => {
    setIsTestLoading(true);
    setShowTestSelector(true);
    setTestInProgress(false);
    setShowSummary(false);
    setCurrentSectionIndex(0);
    setCurrentQuestionIndex(0);
    setResults([]);
    setSelectedOption(null);
    setSelectedTestId(null);
    setProgress(0);

    // Hämta den senaste användarframstegen
    const updatedProgress = await fetchUserProgress();
    setUserProgress(updatedProgress);

    // Tvinga en omrendering av vyn
    setRefreshKey((prevKey) => prevKey + 1);

    setIsTestLoading(false);

    navigate("/app/hogskoleprov");
  };

  const handleOpenOverview = async () => {
    setIsOverviewOpen(true);
    setOverviewLoading(true);
    // Moonshine, dont know if i can comment out loadprogress
    //await loadProgress(selectedTestId);
    //Logger.log('hpTest structure:', JSON.stringify(hpTest, null, 2));

    setOverviewLoading(false);
  };

  const handleCloseOverview = () => {
    setIsOverviewOpen(false);
  };
  useEffect(() => {
    Logger.log("Current progress:", progress);
  }, [progress]);

  useEffect(() => {
    const updateTimerDisplay = () => {
      if (timerDisplayRef.current) {
        const minutes = Math.floor(timeLeftRef.current / 60);
        const seconds = timeLeftRef.current % 60;
        timerDisplayRef.current.textContent = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      }
    };

    const updateTimer = () => {
      if (timeLeftRef.current > 0) {
        timeLeftRef.current -= 1;
        updateTimerDisplay();
      } else {
        handleFinishTest();
        clearInterval(timerRef.current);
      }
    };

    if (testInProgress) {
      timerRef.current = setInterval(updateTimer, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [testInProgress]);

  useEffect(() => {
    if (testInProgress) {
      saveProgress();
    }
  }, [answeredQuestions, results]);

  const handleAskAI = () => {
    Logger.log("Opening AI Dialog from handleAskAI");
    setAiDialogOpen(true);
  };

  useEffect(() => {
    Logger.log("aiDialogOpen useEffect: ", aiDialogOpen);
  }, [aiDialogOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      Logger.log("isAIDialogOpen handleKeyDown: ", aiDialogOpen);
      if (aiDialogOpen) {
        return;
      }

      if (!testInProgress) return;

      const currentSection = hpTest[currentSectionIndex];
      const currentQuestion = currentSection.questions[currentQuestionIndex];
      switch (event.key) {
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
          // Select option based on key press
          const optionIndex = parseInt(event.key) - 1;
          if (
            optionIndex >= 0 &&
            optionIndex < currentQuestion.options.length
          ) {
            handleOptionSelect(currentQuestion.options[optionIndex]);
          }
          break;
        case " ":
        case "Enter":
          // Move to next question with spacebar or enter
          event.preventDefault();
          if (selectedOption) {
            handleNextQuestion();
          }
          break;
        case "ArrowUp":
        case "ArrowDown":
          event.preventDefault();
          const currentOptions = currentQuestion.options;
          const currentIndex = selectedOption
            ? currentOptions.indexOf(selectedOption)
            : -1;
          let newIndex;
          if (event.key === "ArrowUp") {
            newIndex =
              currentIndex > 0 ? currentIndex - 1 : currentOptions.length - 1;
          } else {
            newIndex =
              currentIndex < currentOptions.length - 1 ? currentIndex + 1 : 0;
          }
          handleOptionSelect(currentOptions[newIndex]);
          break;

        case "ArrowLeft":
          handlePreviousQuestion();
          break;
        case "ArrowRight":
          handleNextQuestion();

          break;
        case "Ö":
        case "ö":
          handleOpenOverview();
          break;

        case "S":
        case "s":
          handleSaveQuestion();

          break;
        case "F":
        case "f":
          handleAskAI();
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    currentSectionIndex,
    currentQuestionIndex,
    hpTest,
    testInProgress,
    selectedOption,
    aiDialogOpen,
  ]);

  const startTest = (testId) => {
    setTestInProgress(true);
    setShowTestSelector(false);
    setTimeLeft(55 * 60);

    navigate(`/app/hp/${testId}`);
  };

  const handleOptionSelect = (option) => {
    nextSound.play();
    setSelectedOption(option);
  };

  const getPreviouslySelectedOption = (sectionIndex, questionIndex) => {
    const questionKey = `${sectionIndex}-${questionIndex}`;

    try {
      if (
        !hpTest[sectionIndex] ||
        !hpTest[sectionIndex].questions[questionIndex]
      ) {
        throw new Error(`Invalid section or question index: ${questionKey}`);
      }

      const currentQuestion =
        hpTest[sectionIndex].questions[questionIndex].question;

      if (currentQuestion === undefined) {
        console.warn(`Question is undefined for ${questionKey}`);
        return null;
      }

      const result = results.find(
        (r) =>
          r.questionType === hpTest[sectionIndex].questionType &&
          r.question === currentQuestion,
      );

      return result ? result.selectedOption : null;
    } catch (error) {
      console.error(`Error in getPreviouslySelectedOption: ${error.message}`);
      return null;
    }
  };

  // DETTA FUNKAR JUST NU MEN KANSKE STÄLLER TILL PROBS SENARE. MOONSHINE.
  useEffect(() => {
    if (hpTest) {
      const previouslySelectedOption = getPreviouslySelectedOption(
        currentSectionIndex,
        currentQuestionIndex,
      );
      setSelectedOption(previouslySelectedOption);
    }
  }, [currentSectionIndex, currentQuestionIndex]);

  const jumpToQuestion = (sectionIndex, questionIndex) => {
    selectSound.play();
    setCurrentSectionIndex(sectionIndex);
    setCurrentQuestionIndex(questionIndex);
    const previouslySelectedOption = getPreviouslySelectedOption(
      sectionIndex,
      questionIndex,
    );
    setSelectedOption(previouslySelectedOption);
    handleCloseOverview();
  };

  const handlePreviousQuestion = () => {
    selectSound.play();

    if (currentSectionIndex === 0 && currentQuestionIndex === 0) {
      // Om vi är på första frågan i första sektionen, gör ingenting
      return;
    }

    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    } else if (currentSectionIndex > 0) {
      setCurrentSectionIndex(currentSectionIndex - 1);
      setCurrentQuestionIndex(
        hpTest[currentSectionIndex - 1].questions.length - 1,
      );
    }

    const previousSelectedOption = getPreviouslySelectedOption(
      currentSectionIndex > 0 ? currentSectionIndex - 1 : currentSectionIndex,
      currentQuestionIndex > 0
        ? currentQuestionIndex - 1
        : hpTest[currentSectionIndex - 1].questions.length - 1,
    );

    Logger.log(
      "jumpToQuestion: previousSelectedOption: ",
      previousSelectedOption,
    );
    Logger.log("jumpToQuestion: selectedOption: ", selectedOption);
    setSelectedOption(previousSelectedOption);
  };

  const handleNextQuestion = () => {
    Logger.log("Handling next question. Current state:", {
      currentSectionIndex,
      currentQuestionIndex,
      selectedOption,
    });
    selectSound.play();
    const currentSection = hpTest[currentSectionIndex];
    const currentQuestion = currentSection.questions[currentQuestionIndex];

    if (selectedOption) {
      // Create the new result object
      const newResult = {
        sectionIndex: currentSectionIndex,
        questionIndex: currentQuestionIndex,
        questionType: currentSection.questionType,
        question: currentQuestion.question,
        selectedOption,
        correctAnswer: currentQuestion.correctAnswer,
        isCorrect: selectedOption === currentQuestion.correctAnswer,
      };

      // Check if we're on the last question
      const isLastQuestion =
        currentSectionIndex === hpTest.length - 1 &&
        currentQuestionIndex === currentSection.questions.length - 1;

      // Update the results state with the new answer
      setResults((prev) => {
        const existingIndex = prev.findIndex(
          (r) =>
            r.sectionIndex === currentSectionIndex &&
            r.questionIndex === currentQuestionIndex,
        );

        let updatedResults;
        if (existingIndex !== -1) {
          updatedResults = [...prev];
          updatedResults[existingIndex] = newResult;
        } else {
          updatedResults = [...prev, newResult];
        }

        // If this is the last question, save progress and then check if we can finish the test
        if (isLastQuestion) {
          // First save the progress with the updated results
          saveProgress({ results: updatedResults });

          // Then check if all questions are answered and handle test completion
          const totalQuestions = calculateTotalQuestions(hpTest);
          const answeredCount = updatedResults.length;
          const allAnswered = answeredCount >= totalQuestions;

          if (allAnswered) {
            // If all questions are answered, we can finish the test directly
            Logger.log(
              "All questions answered. Finishing test with results:",
              updatedResults,
            );
            setShowSummary(true);
            setTestInProgress(false);
            saveResultsToDatabase(updatedResults);
            doneSound.play();
          } else {
            // If not all questions are answered, show the incomplete dialog
            setIncompleteDialogOpen(true);
          }
        }

        return updatedResults;
      });

      // If it's the last question, we've already handled it above, so return early
      if (isLastQuestion) {
        return;
      }

      // Not the last question, so save progress normally
      saveProgress();
    }

    // Move to next question (only if not the last question)
    if (currentQuestionIndex < currentSection.questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else if (currentSectionIndex < hpTest.length - 1) {
      setCurrentSectionIndex(currentSectionIndex + 1);
      setCurrentQuestionIndex(0);
    }

    const nextSelectedOption = getPreviouslySelectedOption(
      currentSectionIndex,
      currentQuestionIndex < currentSection.questions.length - 1
        ? currentQuestionIndex + 1
        : 0,
    );
    setSelectedOption(nextSelectedOption);
  };
  // const handleNextQuestion = () => {
  //   Logger.log("Handling next question. Current state:", {
  //     currentSectionIndex,
  //     currentQuestionIndex,
  //     selectedOption,
  //   });
  //   selectSound.play();
  //   const currentSection = hpTest[currentSectionIndex];
  //   const currentQuestion = currentSection.questions[currentQuestionIndex];

  //   if (selectedOption) {
  //     setResults((prev) => {
  //       const existingIndex = prev.findIndex(
  //         (r) =>
  //           r.sectionIndex === currentSectionIndex &&
  //           r.questionIndex === currentQuestionIndex,
  //       );
  //       const newResult = {
  //         sectionIndex: currentSectionIndex,
  //         questionIndex: currentQuestionIndex,
  //         questionType: currentSection.questionType,
  //         question: currentQuestion.question,
  //         selectedOption,
  //         correctAnswer: currentQuestion.correctAnswer,
  //         isCorrect: selectedOption === currentQuestion.correctAnswer,
  //       };

  //       if (existingIndex !== -1) {
  //         const updated = [...prev];
  //         updated[existingIndex] = newResult;
  //         return updated;
  //       } else {
  //         return [...prev, newResult];
  //       }
  //     });

  //     saveProgress();

  //     if (
  //       currentSectionIndex === hpTest.length - 1 &&
  //       currentQuestionIndex === currentSection.questions.length - 1
  //     ) {
  //       Logger.log("Reached last question. Results:", results);
  //       setTimeout(() => handleFinishTest(), 0);
  //       return;
  //     }
  //   }

  //   // Move to next question
  //   if (currentQuestionIndex < currentSection.questions.length - 1) {
  //     setCurrentQuestionIndex(currentQuestionIndex + 1);
  //   } else if (currentSectionIndex < hpTest.length - 1) {
  //     setCurrentSectionIndex(currentSectionIndex + 1);
  //     setCurrentQuestionIndex(0);
  //   }

  //   const nextSelectedOption = getPreviouslySelectedOption(
  //     currentSectionIndex,
  //     currentQuestionIndex < currentSection.questions.length - 1
  //       ? currentQuestionIndex + 1
  //       : 0,
  //   );
  //   setSelectedOption(nextSelectedOption);
  // };

  const handleFinishTest = () => {
    const totalQuestions = calculateTotalQuestions(hpTest);
    const answeredCount = results.length;

    const allAnswered = answeredCount >= totalQuestions;

    Logger.log(
      `Total questions: ${totalQuestions}, Answered: ${answeredCount}, All answered: ${allAnswered}`,
    );

    if (!allAnswered) {
      setIncompleteDialogOpen(true);
      return;
    }

    const finalTimeLeft = timeLeftRef.current;
    Logger.log("Finishing test. Final timeLeft:", finalTimeLeft);

    // Ensure we have the latest results
    setResults((prevResults) => {
      Logger.log("Final Results:", prevResults);
      setShowSummary(true);
      setTestInProgress(false);
      saveResultsToDatabase(prevResults);
      doneSound.play();
      return prevResults;
    });
  };
  // const handleFinishTest = () => {
  //   const totalQuestions = calculateTotalQuestions(hpTest);
  //   const answeredCount =
  //     Object.values(answeredQuestions).filter(Boolean).length;

  //   Logger.log(
  //     `Total questions: ${totalQuestions}, Answered: ${answeredCount}`,
  //   );

  //   // if (!allAnswered) {
  //   //   setIncompleteDialogOpen(true);
  //   //   return;
  //   // }

  //   const finalTimeLeft = timeLeftRef.current;
  //   Logger.log("Finishing test. Final timeLeft:", finalTimeLeft);

  //   // Ensure we have the latest results
  //   setResults((prevResults) => {
  //     Logger.log("Final Results:", prevResults);
  //     setShowSummary(true);
  //     setTestInProgress(false);
  //     saveResultsToDatabase(prevResults);
  //     doneSound.play();
  //     return prevResults;
  //   });
  // };

  const saveResultsToDatabase = async (resultsToSave) => {
    // try {
    //   await addDoc(collection(db, 'hpTestResults'), {
    //     userId: user.uid,
    //     results: resultsToSave,
    //     date: new Date(),
    //     totalTime: 55 * 60 - timeLeft
    //   });
    // } catch (error) {
    //   console.error('Error saving HP test results:', error);
    // }
  };

  if (!hpTest || isTestLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
        }}
      >
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>{dynamicTitle}</title>
        <meta name="description" content={dynamicDescription} />
      </Helmet>

      <Box sx={styles.container}>
        <Box sx={styles.innerContainer}>
          {showOverlay && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <CircularProgress size={60} sx={{ color: "white" }} />
              <Typography variant="h5" sx={{ color: "white", mt: 2 }}>
                Förbereder ditt högskoleprov...
              </Typography>
            </Box>
          )}

          {!testInProgress && (
            <>
              {!showSummary && (
                <>
                  <Typography
                    variant="h1"
                    sx={{ ...styles.newH1, textAlign: "center" }}
                  >
                    {user.accountType === "student"
                      ? "Högskoleprov"
                      : "Generera prov"}
                  </Typography>
                </>
              )}
            </>
          )}
          {showManualTest && (
            <Box
              sx={{
                mt: 2,
                mb: 4,
                p: 3,
                backgroundColor:
                  theme.palette.mode === "dark" ? "#22303C" : "#fff",
                borderRadius: "8px",
                border:
                  theme.palette.mode === "dark"
                    ? "1px solid #263442"
                    : "1px solid #e0e0e091",
              }}
            >
              <Typography variant="h5" sx={{ mb: 2 }}>
                Add Manual Test
              </Typography>
              <form onSubmit={handleManualTestSubmit}>
                <TextField
                  fullWidth
                  label="Test Name"
                  value={manualTestName}
                  onChange={(e) => setManualTestName(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Test JSON"
                  value={manualTestJson}
                  onChange={(e) => setManualTestJson(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <Button type="submit" variant="contained" color="primary">
                  Add Test
                </Button>
              </form>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={copyTest}
              >
                kopiera
              </Button>
            </Box>
          )}

          <AIDialog
            userId={user.uid}
            open={aiDialogOpen}
            onClose={() => {
              Logger.log("Closing AI Dialog");
              setAiDialogOpen(false);
            }}
            initialQuestion={
              hpTest[currentSectionIndex].questions[currentQuestionIndex]
                ? `Question: ${hpTest[currentSectionIndex].questions[currentQuestionIndex].question}\nOptions: ${hpTest[currentSectionIndex].questions[currentQuestionIndex].options.join(", ")}\nPlease explain this question and help me understand the answer options. Skriv på svenska.`
                : "No question available"
            }
            systemMessage="You are a helpful AI assistant designed to explain and assist with högskoleprovet (Swedish Scholastic Aptitude Test) questions. Provide clear, pedagogical explanations using analogies and examples when appropriate. Skriv på svenska"
            theme={theme}
          />

          <IncompleteTestDialog
            open={incompleteDialogOpen}
            onClose={() => {
              setIncompleteDialogOpen(false);
              setIsOverviewOpen(true);
            }}
          />

          <Box
            sx={{
              ...styles.buttonsContainer,
              ...styles.additionalButtonsContainer,
            }}
          >
            {isMobile ? (
              <Button
                variant="contained"
                color="primary"
                disableRipple
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/app/hogskoleprov");
                }}
                startIcon={
                  <ExploreIcon
                    sx={{
                      color: theme.palette.mode === "dark" ? "#fff" : "#8b5cf6",
                    }}
                  />
                }
                sx={{ ...styles.shrinkButton, display: "none" }}
              ></Button>
            ) : (
              <>
                {!testInProgress && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableRipple
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/app/hogskoleprov");
                    }}
                    sx={{ display: "none" }}
                    startIcon={
                      <ExploreIcon
                        sx={{
                          color:
                            theme.palette.mode === "dark" ? "#fff" : "#8b5cf6",
                        }}
                      />
                    }
                  >
                    Alla högskoleprov
                  </Button>
                )}
              </>
            )}
            {!testInProgress && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  disableRipple
                  onClick={handleBackToSelector}
                  startIcon={<AddIcon />}
                  sx={{ ...styles.shrinkButton, display: "none" }}
                />

                <Button
                  variant="contained"
                  color="primary"
                  disableRipple
                  onClick={() => setDrawerOpen(true)}
                  startIcon={<SegmentIcon />}
                  sx={{
                    padding: "8px",
                    marginRight: "0px",
                    paddingLeft: "14px",
                    paddingRight: "3px",
                    minWidth: "auto",
                    textTransform: "none",
                  }}
                />
              </>
            )}
          </Box>

          <HPDrawerComponent
            user={user}
            theme={theme}
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          />

          {showTestSelector && (
            <>
              <GenerateHP user={user} theme={theme} styles={styles} />
              <Box sx={{ display: "none" }}>
                <Typography variant="h3" sx={{ ...styles.h3, mt: 7 }}>
                  Dina högskoleprov
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    ...styles.h5,
                    display: "inline-flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <InfoIcon sx={{ mr: 1, fontSize: "17px" }} />
                  De kvantitativa delarna kommer snart.
                </Typography>

                {isLoadingTests ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <LoadingSpinner />
                    {/* <Typography variant="body1" sx={{ ml: 2 }}>
                  Laddar sparade högskoleprov...
                </Typography>*/}
                  </Box>
                ) : (
                  <>
                    {/*
                    <TestSelector
                      onSelectTest={handleSelectTest}
                      userProgress={userProgress}
                      key={refreshKey}
                      allTests={allTests}
                      onDeleteTest={handleDeleteGeneratedTest}
                    />
                    */}
                  </>
                )}
              </Box>
            </>
          )}

          {testInProgress && hpTest && hpTest.length > 0 && (
            <TestInProgressComponent
              hpTest={hpTest}
              showSnackbar={showSnackbar}
              currentHpName={currentHpName}
              currentSectionIndex={currentSectionIndex}
              currentQuestionIndex={currentQuestionIndex}
              focusModeActive={focusModeActive}
              toggleFocusMode={toggleFocusMode}
              timeLeft={timeLeft}
              timeLeftRef={timeLeftRef}
              timerDisplayRef={timerDisplayRef}
              selectedOption={selectedOption}
              handleOptionSelect={handleOptionSelect}
              handleOpenOverview={handleOpenOverview}
              handleSubmitTest={handleFinishTest}
              handlePreviousQuestion={handlePreviousQuestion}
              handleNextQuestion={handleNextQuestion}
              handleSaveQuestion={handleSaveQuestion}
              handleAskAI={handleAskAI}
              isSaved={isSaved}
              results={results}
              testId={selectedTestId}
              user={user}
              theme={theme}
              styles={styles}
              setDrawerOpen={setDrawerOpen}
              isMobile={isMobile}
            />
          )}

          {showSummary && (
            <TestResultComponent
              results={results}
              hpTest={hpTest}
              timeLeftRef={timeLeftRef}
              handleBackToSelector={handleBackToSelector}
              styles={styles}
              theme={theme}
              user={user}
            />
          )}
        </Box>
        <Dialog
          open={isOverviewOpen}
          onClose={handleCloseOverview}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              width: "85%",
              maxWidth: "850px",
              maxHeight: "80vh",
            },
          }}
        >
          <DialogTitle
            sx={{
              m: 0,
              p: 2,
              backgroundColor:
                theme.palette.mode === "dark" ? "#192734" : "white",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseOverview}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.mode === "dark" ? "white" : "black",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              backgroundColor:
                theme.palette.mode === "dark" ? "#192734" : "white",
            }}
          >
            {overviewLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ p: 3 }}>
                <Typography variant="h3" sx={{ ...styles.h3, mb: 3 }}>
                  Översikt
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { sm: "space-around" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: { xs: 2, sm: 0 },
                    mb: 6,
                    p: 2,
                    backgroundColor:
                      theme.palette.mode === "dark" ? "#3e4a55" : "#eee9ff",
                    borderRadius: "8px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CheckCircleIcon
                      color="success"
                      sx={{ mr: 1, width: "18px", height: "18px" }}
                    />
                    <Typography>Besvarad</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <WarningIcon
                      color="warning"
                      sx={{ mr: 1, width: "18px", height: "18px" }}
                    />
                    <Typography>Ej besvarad</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <StarIcon
                      color="info"
                      sx={{ mr: 1, width: "18px", height: "18px" }}
                    />
                    <Typography>Sparad fråga</Typography>
                  </Box>
                </Box>

                {hpTest.map((section, sectionIndex) => (
                  <Box key={section.questionType} sx={{ mb: 4 }}>
                    <Typography
                      variant="h3"
                      sx={{ ...styles.h3, fontWeight: "bold", mb: 2 }}
                    >
                      {section.questionType}
                    </Typography>
                    <Grid container spacing={2}>
                      {section.questions.map((_, questionIndex) => {
                        const answeredQuestion = results.find(
                          (r) =>
                            r.sectionIndex === sectionIndex &&
                            r.questionIndex === questionIndex,
                        );

                        let status = "Ej besvarad";
                        let color = "warning.main";
                        let icon = (
                          <WarningIcon sx={{ width: "18px", height: "18px" }} />
                        );

                        if (answeredQuestion) {
                          if (answeredQuestion.saved) {
                            status = "Sparad fråga";
                            color = "info.main";
                            icon = (
                              <StarIcon
                                sx={{ width: "18px", height: "18px" }}
                              />
                            );
                          } else {
                            status = "Besvarad";
                            color = "success.main";
                            icon = (
                              <CheckCircleIcon
                                sx={{ width: "18px", height: "18px" }}
                              />
                            );
                          }
                        }

                        return (
                          <Grid item key={`${sectionIndex}-${questionIndex}`}>
                            <Tooltip title={status}>
                              <Button
                                variant="outlined"
                                size="large"
                                onClick={() =>
                                  jumpToQuestion(sectionIndex, questionIndex)
                                }
                                sx={{
                                  minWidth: "60px",
                                  height: "30px",
                                  p: 0,
                                  color: color,
                                  borderColor: color,
                                  backgroundColor:
                                    theme.palette.mode === "dark"
                                      ? "#22303C"
                                      : "#f8f8f8",
                                  border:
                                    theme.palette.mode === "dark"
                                      ? "1px solid #3E5366"
                                      : "1px solid #f1f1f1",
                                  "&:hover": {
                                    backgroundColor: `${color}10`,
                                  },
                                }}
                                startIcon={icon}
                              >
                                {questionIndex + 1}
                              </Button>
                            </Tooltip>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                ))}
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default HP;
